export let post_config = [
	{
        elements: [
			{
				elementGetParamMap: 'test_filter_select',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: '',
				element_model_default: '',
				label: '',
				placeholder: 'Выбрать соту',
				filterable: true,
				options:[
					{value: '1', label: 'ID 1 Сота блабла',},
					{value: '2', label: 'ID 2 Сота блабла',},
					{value: '3', label: 'ID 3 Сота блабла',},
				]
			},
			{
				elementGetParamMap: 'test_ajax_list',
				elementType: 'ajax-list',
				element_model: {},
				label: '',
				placeholder:"Выберите ответственного",
				objApiMethod:{'obj':'staff' ,'flt':{'fio':''}},
				strApiMethodKey:"fio",
			},
			
			{
				elementGetParamMap: 'test_multi_select1',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: [],
				label: '',
				placeholder: 'Выбрать класс жилья',
				multiple: true,
				options:[
					{value: '1', label: 'Стандарт',},
					{value: '2', label: 'Бизнес',},
					{value: '3', label: 'Комфорт',},
				]
			},
			{
				elementGetParamMap: 'test_multi_select2',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: [],
				label: '',
				placeholder: 'Выбрать тип жилья',
				multiple: true,
				options:[
					{value: '1', label: 'Квартира'},
					{value: '2', label: 'Комната'},
					{value: '3', label: 'Дом'},
					{value: '4', label: 'Участок'},
					{value: '5', label: 'Коммерция'},
				]
			},
			{
				elementGetParamMap: 'test_multi_select3',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: [],
				label: '',
				placeholder: 'Выбрать комнатность',
				multiple: true,
				options:[
					{value: '1', label: 'Студия',},
					{value: '2', label: '1ккв',},
					{value: '3', label: '2ккв',},
				]
			},
        ]

    }
]